/**
 * Offline handling — rejects fast when navigator reports offline so UI can show banner.
 * (Full request replay needs adapter-level customization; callers can retry manually after reconnect.)
 */

import type { AxiosError } from 'axios'

let onlineListenersAttached = false

export function initOfflineBroadcast(): void {
  if (onlineListenersAttached) return
  onlineListenersAttached = true
  if (typeof window === 'undefined') return

  /** Reserved for incremental replay integrations */
  window.addEventListener('online', () => {
    window.dispatchEvent(new CustomEvent('vidhyantra-online'))
  })

  window.addEventListener('offline', () => {
    window.dispatchEvent(new CustomEvent('vidhyantra-offline'))
  })
}

export function isBrowserOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}

export function buildOfflineRejectedError(url?: string): AxiosError {
  const err = new Error('You appear to be offline. Check your connection.') as AxiosError
  err.name = 'OfflineError'
  err.code = 'ERR_OFFLINE'
  err.config = { url } as AxiosError['config']
  ;(err as AxiosError).isAxiosError = true
  return err
}
